import React from "react";
import { SEO, MainLayout, ChangePassword } from "../../../components";

const ChangePasswordPage = () => {
  return (
    <>
      <SEO title="Change Password" />
      <MainLayout>
        <ChangePassword />
      </MainLayout>
    </>
  );
};

export default ChangePasswordPage;
